/* GoGo Solar — reviews carousel (real Fera data) and the 10% signup block.

   The signup block hands off to the real Liquid customer form rendered by
   snippets/bsl-real-forms.liquid, exactly as the popup does. It used to
   build its own form and post it with fetch(), which always failed: the
   store has reCAPTCHA on customer forms and a hand-built form carries no
   token, so Shopify answered 400 "Missing CAPTCHA token" every time.

   Success is read from Shopify's own verdict on #bsl-real-customer-result,
   never from the address bar. An earlier attempt trusted
   ?customer_posted=true and showed a confirmation for a signup that had
   created nothing.

   The perk list used to promise a free 20W solar light with no discount
   behind it. There is now an automatic Buy X Get Y discount in Shopify that
   actually gives one on every order, so the line is honest again. */
(function () {
  var GOLD = "#F5A800";
  var PENDING = "bsl-promo-pending";

  var DATA = {
    average: 4.8,
    count: 200,
    items: [
      { r: 5, n: "Jordie", h: "Definitely recommended!", b: "I like the 800W light, brought a few for my field. Also the plan is a good addition. Thanks", p: "800W Solar Street Light" },
      { r: 5, n: "Tarique", h: "", b: "Very happy with this system, I can finally monitor my property 24/7", p: "AI 12MP Solar CCTV Camera" },
      { r: 5, n: "Mateusz", h: "", b: "Love this design, I would recommend this if you're sitting outside in your garden", p: "Garden Solar Lamp" },
      { r: 5, n: "Nadir", h: "", b: "Really bright and easy to install — couldn't ask for more.", p: "20W LED Solar Outdoor Lights" },
      { r: 5, n: "Harry", h: "", b: "To be honest I take this out and about with me. Definitely recommend this", p: "800W Solar Street Light" },
      { r: 5, n: "Leo", h: "", b: "Works well even on cloudy days, happy with it.", p: "2500W Ultra Solar Street Light" },
      { r: 5, n: "Sipho", h: "", b: "It actually lasts for 12 hours", p: "2000W LED Street Light" },
      { r: 5, n: "H", h: "", b: "I was surprised by how bright it is, love it.", p: "2000W LED Street Light" },
      { r: 4, n: "Oliver", h: "", b: "Very reliable and looks neat once fitted.", p: "800W Solar Street Light" },
      { r: 5, n: "Antoine", h: "", b: "Solid build, feels durable and well made.", p: "20W LED Solar Outdoor Lights" },
      { r: 4, n: "Lucas", h: "", b: "Super bright and charges fast.", p: "2000W LED Street Light" },
      { r: 5, n: "George", h: "", b: "Saves me money and gives great light output.", p: "20W LED Solar Outdoor Lights" },
      { r: 5, n: "Oluwaseun", h: "", b: "It actually lasts longer than 4 hours — they should change the description", p: "400W LED Street Lights" },
      { r: 4, n: "Joseph", h: "", b: "Great for my driveway, easy setup.", p: "400W LED Street Lights" },
      { r: 4, n: "Liam", h: "", b: "It's heavy — good for the wind", p: "2000W LED Street Light" }
    ]
  };

  function stars(n) {
    var o = "";
    for (var i = 1; i <= 5; i++) o += i <= n ? "★" : "☆";
    return o;
  }

  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function reviewsHTML() {
    var cards = DATA.items.map(function (x) {
      return (
        '<article class="bsl-rv-card">' +
          '<div class="bsl-rv-stars">' + stars(x.r) + "</div>" +
          (x.h ? '<h3 class="bsl-rv-h">' + esc(x.h) + "</h3>" : "") +
          '<p class="bsl-rv-body">“' + esc(x.b) + "”</p>" +
          '<div class="bsl-rv-foot">' +
            '<span class="bsl-rv-name">' + esc(x.n) +
              '<span class="bsl-rv-verified">Verified buyer</span></span>' +
            '<span class="bsl-rv-prod">' + esc(x.p || "") + "</span>" +
          "</div>" +
        "</article>"
      );
    }).join("");

    return (
      '<div class="bsl-rv-inner">' +
        '<div class="bsl-rv-head">' +
          "<div>" +
            '<p class="bsl-rv-label">What customers say</p>' +
            '<h2 class="bsl-rv-title">Rated by the people<br>who fitted them.</h2>' +
          "</div>" +
          '<div class="bsl-rv-headright">' +
            '<a class="bsl-rv-score" href="/pages/reviews" aria-label="Read all customer reviews">' +
              '<span class="num">' + DATA.average.toFixed(1) + "</span>" +
              "<span>" +
                '<span class="bsl-rv-stars">' + stars(Math.round(DATA.average)) + "</span><br>" +
                '<span class="meta">' + DATA.count + " reviews</span>" +
              "</span>" +
            "</a>" +
            '<div class="bsl-rv-nav">' +
              '<button type="button" class="bsl-rv-btn" data-dir="-1" aria-label="Previous reviews">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="m15 18-6-6 6-6"/></svg>' +
              "</button>" +
              '<button type="button" class="bsl-rv-btn" data-dir="1" aria-label="Next reviews">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="m9 18 6-6-6-6"/></svg>' +
              "</button>" +
            "</div>" +
          "</div>" +
        "</div>" +
        '<div class="bsl-rv-track" id="bsl-rv-track">' + cards + "</div>" +
        '<div class="bsl-rv-cta">' +
          '<a href="/pages/reviews" class="bsl-rv-all-link">View all ' + DATA.count + " reviews →</a>" +
        "</div>" +
      "</div>"
    );
  }

  function promoHTML() {
    return (
      '<div class="bsl-promo-inner">' +
        '<p class="bsl-promo-label">Join the community</p>' +
        '<h2 class="bsl-promo-title">Get <span>10% off</span><br>your first order</h2>' +
        '<p class="bsl-promo-copy">Sign up and we’ll send your discount code straight to your inbox. ' +
          "Be first to hear about new arrivals, exclusive deals, and our mission to make clean light " +
          "accessible for all.</p>" +
        '<form class="bsl-promo-form" id="bsl-promo-form" novalidate>' +
          '<input type="email" name="email" placeholder="Enter your email address" required>' +
          '<button type="submit">Send my code</button>' +
        "</form>" +
        '<div class="bsl-promo-perks">' +
          "<span>10% off first order</span>" +
          "<span>Free 20W solar light</span>" +
          "<span>Your own code, valid 30 days</span>" +
        "</div>" +
      "</div>"
    );
  }

  function carouselStyles() {
    if (document.getElementById("bsl-rv-carousel-style")) return;
    var s = document.createElement("style");
    s.id = "bsl-rv-carousel-style";
    s.textContent = [
      ".bsl-rv-headright{display:flex;align-items:center;gap:1.4rem}",
      ".bsl-rv-nav{display:flex;gap:.5rem}",
      ".bsl-rv-btn{width:42px;height:42px;border-radius:50%;border:1px solid rgba(23,26,21,.18);" +
        "background:#fff;color:#171A15;display:flex;align-items:center;justify-content:center;" +
        "cursor:pointer;transition:all .18s}",
      ".bsl-rv-btn:hover{background:#171A15;color:#fff;border-color:#171A15}",
      ".bsl-rv-btn[disabled]{opacity:.3;cursor:default}",
      ".bsl-rv-btn[disabled]:hover{background:#fff;color:#171A15;border-color:rgba(23,26,21,.18)}",
      ".bsl-rv-track{display:flex;gap:1.1rem;overflow-x:auto;scroll-behavior:smooth;" +
        "scroll-snap-type:x mandatory;-ms-overflow-style:none;scrollbar-width:none;" +
        "padding-bottom:.25rem}",
      ".bsl-rv-track::-webkit-scrollbar{display:none}",
      ".bsl-rv-track > .bsl-rv-card{flex:0 0 calc((100% - 2.2rem)/3);scroll-snap-align:start;min-height:210px}",
      "@media(max-width:980px){.bsl-rv-track > .bsl-rv-card{flex:0 0 calc((100% - 1.1rem)/2)}}",
      "@media(max-width:640px){.bsl-rv-track > .bsl-rv-card{flex:0 0 88%}" +
        ".bsl-rv-headright{width:100%;justify-content:space-between}}",
      ".bsl-rv-cta{text-align:center;margin-top:1.8rem}",
      ".bsl-rv-all-link{font-family:Inter,system-ui,sans-serif;font-size:.88rem;font-weight:500;" +
        "color:#171A15;text-decoration:none;border-bottom:1px solid " + GOLD + ";padding-bottom:2px}",
      ".bsl-rv-all-link:hover{color:" + GOLD + "}",
      ".bsl-promo-err{margin-top:1rem;font-family:Inter,system-ui,sans-serif;font-size:.82rem;" +
        "color:#FFB4AD}"
    ].join("");
    document.head.appendChild(s);
  }

  function wireCarousel() {
    var track = document.getElementById("bsl-rv-track");
    if (!track || track.dataset.bslWired) return;
    track.dataset.bslWired = "1";

    var btns = document.querySelectorAll(".bsl-rv-btn");

    function step() {
      var card = track.querySelector(".bsl-rv-card");
      if (!card) return 320;
      var gap = parseFloat(getComputedStyle(track).gap) || 18;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      btns.forEach(function (b) {
        var dir = parseInt(b.dataset.dir, 10);
        if (dir < 0) b.disabled = track.scrollLeft <= 2;
        else b.disabled = track.scrollLeft >= max;
      });
    }

    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        track.scrollBy({ left: parseInt(b.dataset.dir, 10) * step(), behavior: "smooth" });
      });
    });

    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  function findGallery() {
    var hs = document.querySelectorAll("h2");
    for (var i = 0; i < hs.length; i++) {
      if (/lit by nothing but sunlight|lit by sunlight/i.test(hs[i].textContent)) {
        return hs[i].closest("section") || hs[i].parentElement;
      }
    }
    return null;
  }

  function pending() {
    try { return sessionStorage.getItem(PENDING); } catch (e) { return null; }
  }

  function setPending(v) {
    try {
      if (v === null) sessionStorage.removeItem(PENDING);
      else sessionStorage.setItem(PENDING, v);
    } catch (e) {}
  }

  function verdict() {
    var el = document.getElementById("bsl-real-customer-result");
    if (!el) return null;
    return { ok: el.getAttribute("data-ok") === "1", msg: el.getAttribute("data-msg") || "" };
  }

  function build() {
    carouselStyles();

    var gal = findGallery();
    if (gal && !document.getElementById("bsl-reviews")) {
      var rv = document.createElement("section");
      rv.id = "bsl-reviews";
      rv.innerHTML = reviewsHTML();
      gal.replaceWith(rv);
    }
    wireCarousel();

    if (!document.getElementById("bsl-promo")) {
      var quote = document.getElementById("quote");
      if (!quote) {
        var hs = document.querySelectorAll("h2");
        for (var i = 0; i < hs.length; i++) {
          if (/light up your space/i.test(hs[i].textContent)) {
            quote = hs[i].closest("section") || hs[i].parentElement;
            break;
          }
        }
      }
      if (quote && quote.parentElement) {
        var pr = document.createElement("section");
        pr.id = "bsl-promo";
        pr.innerHTML = promoHTML();
        quote.parentElement.insertBefore(pr, quote);
      }
    }

    var form = document.getElementById("bsl-promo-form");
    if (form && !form.dataset.bslBound) {
      form.dataset.bslBound = "1";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var email = input ? (input.value || "").trim() : "";
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          failed("Please enter a valid email address.");
          return;
        }

        var real = document.getElementById("bsl-real-customer-form");
        var field = document.getElementById("bsl-real-customer-email");
        if (!real || !field) {
          failed("The signup form did not load on this page, so nothing was sent. " +
                 "Please email info@gogosolar.co.uk and we’ll add you by hand.");
          return;
        }

        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }

        field.value = email;
        setPending(email);
        try {
          if (typeof real.requestSubmit === "function") real.requestSubmit();
          else {
            var rb = real.querySelector('button[type="submit"]');
            if (rb) rb.click(); else throw new Error("no submit button");
          }
        } catch (err) {
          setPending(null);
          if (btn) { btn.disabled = false; btn.textContent = "Send my code"; }
          failed("Something went wrong sending that. Please try again, or email info@gogosolar.co.uk.");
        }
        /* the page navigates from here if the hand-off worked */
      });
    }

    /* coming back from a real submission: report what Shopify actually said */
    var v = verdict();
    if (v && pending()) {
      setPending(null);
      if (v.ok) done();
      else failed(v.msg || "Something went wrong sending that. Please try again, or email info@gogosolar.co.uk.");
    }

    function failed(msg) {
      var inner = document.querySelector(".bsl-promo-inner");
      if (!inner) return;
      var old = document.querySelector(".bsl-promo-err");
      if (old) old.remove();
      var p = document.createElement("p");
      p.className = "bsl-promo-err";
      p.textContent = msg;
      inner.appendChild(p);
    }

    function done() {
      var inner = document.querySelector(".bsl-promo-inner");
      if (!inner) return;
      var f = document.getElementById("bsl-promo-form");
      if (f) f.style.display = "none";
      var old = document.querySelector(".bsl-promo-err");
      if (old) old.remove();
      if (!document.querySelector(".bsl-promo-done")) {
        var p = document.createElement("p");
        p.className = "bsl-promo-done";
        p.textContent = "✓ You’re in — check your inbox for your code.";
        inner.appendChild(p);
      }
    }
  }

  new MutationObserver(build).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") build();
  else document.addEventListener("DOMContentLoaded", build);
  window.addEventListener("load", build);
})();
